import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

export interface TocItem {
  id: string;
  text: string;
  depth: number;
}

@Injectable({ providedIn: 'root' })
export class DocNavigationService {
  // Il BehaviorSubject mantiene l'ultimo stato del menu
  private menuSource = new BehaviorSubject<TocItem[]>([]);
  
  // Observable che la sidebar sottoscriverà
  menu$ = this.menuSource.asObservable();

  updateMenu(items: TocItem[]) {
    this.menuSource.next(items);
  }
}